/* @ngInject */
const metadata = (
  dispatchFields,
  dispatchButtons
) => {
  const self = {}

  self.favoriteSort = ['-date',]

  self.buttons = [
    dispatchButtons.search,
    dispatchButtons.edit,
    dispatchButtons.delete,
  ]

  self.fields = dispatchFields

  return self
}

export default metadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/services/metadata.service.js